module.exports = __webpack_public_path__ + "static/media/bg-3-art.b774ec6f.png";